module.exports = __webpack_public_path__ + "static/media/logo-light.81b8a3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-light.png
// module id = 282
// module chunks = 0